export enum ProviderOnlineStatus {
  yes = "YES",
  no = "NO",
  callClinic = "CALL"
}

export enum Environment {
  Dev = "deva",
  Uat = "uata",
  Prod = "proda"
}
